import React, { useState, useEffect, useRef } from 'react'; //ai useRef
import { useNavigate } from 'react-router-dom';
import { UrlDev } from './url'; // ✅ Import your base URL
import { authFetch } from './utils/api'; // ✅ Import fetch wrapperL
import { useLocation } from 'react-router-dom';
import { alertC, confirmC } from './components/dialogService';


import ItemSelector from './itemselector'; // Ensure the path is correct and in lowercase
import ExpandableSection from './expandablesection';
import Drawing from './drawing';
import DrawTopView from './draw_top_view';
import './entrydoor.css'; // Import the CSS file for styles
import './toolbar.css';
import './spinner.css';
import InteriorDoor from './controls/finish/InteriorDoor';
import ExteriorDoor from './controls/finish/ExteriorDoor';
import LocationTag from './controls/LocationTag';
import Notes from './controls/Notes';
import Quantity from './controls/frame/Quantity';
import Discount from './controls/frame/Discount';
import FrameColor from './controls/finish/eticom/FrameColor';
import ScreenFrameColor from './controls/finish/eticom/ScreenFrameColor';
import FrameWidthEticom from './controls/frame/eticom/FrameWidthEticom';
import FrameHeightEticom from './controls/frame/eticom/FrameHeightEticom';
import SideLiteSize from './controls/frame/SideLiteSize';
import HardwareCollection from './controls/frame/eticom/HardwareCollection';
import HardwareFinish from './controls/frame/eticom/HardwareFinish';
import Hinges from './controls/frame/Hinges';
import HingesCoverColor from './controls/frame/eticom/HingesCoverColor';
import Swing from './controls/frame/Swing';
import OptionS from './controls/doorlite/eticom/OptionS';
import GlassDividers from './controls/doorlite/eticom/GlassDividers';
import GlassDividersHorizontal from './controls/doorlite/eticom/GlassDividersHorizontal';
import GlassDividersVertical from './controls/doorlite/eticom/GlassDividersVertical';
import ExteriorFinish from './controls/doorlite/eticom/ExteriorFinish';
import InteriorFinish from './controls/doorlite/eticom/InteriorFinish';
import GentekColor from './controls/finish/GentekColor';
import Transom from './controls/transom/Transom';
import TransomGlass from './controls/transom/TransomGlass';
import OverallHeight from './controls/transom/OverallHeight';
import FrameDepth from './controls/frame/eticom/FrameDepth';
import SillOptions from './controls/frame/SillOption';
import RetractableScreen from './controls/frame/eticom/RetractableScreen';
import ScreenFrameMatch from './controls/ScreenFrameMatch';
import SideLiteTypeEticom from './controls/sidelite/eticom/SideLiteTypeEticom';
import SideLiteOptionsEticom from './controls/sidelite/eticom/SideLiteOptionsEticom';
import GlassDividersSideLiteEticom from './controls/sidelite/eticom/GlassDividersSideLiteEticom';
import GlassDividersHorizontalSideLiteEticom from './controls/sidelite/eticom/GlassDividersHorizontalSideLiteEticom';
import GlassDividersVerticalSideLiteEticom from './controls/sidelite/eticom/GlassDividersVerticalSideLiteEticom';
import ExteriorFinishSideLiteEticom from './controls/sidelite/eticom/ExteriorFinishSideLiteEticom';
import InteriorFinishSideLiteEticom from './controls/sidelite/eticom/InteriorFinishSideLiteEticom';
import CascadingCombo from './additional/CascadingCombo';

import { toPdf, toPdfAuto } from './components/toPdf';
import EmailDialog from './records/EmailDialog';

import ViewDetails from './docs/viewdetails'; // Import sliding window
import { formatToDecimal } from './controls/conversions';
import { formatToFractional } from './controls/conversions';
import { getCookie } from './utils/cookies';
import { authFetchRequest } from './utils/api';
import { getCustomerEmail } from './utils/QuickDataAccess';

const EntryDoorEticom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { quoteId, quoteItemId, fkCustomerId, fkUserId, viewItem, reference_no } = location.state || {};
  const [newQuoteItemId, setNewQuoteItemId] = useState(quoteItemId || null);
  const [lastDateSaved, setLastDateSaved] = useState("NA");
  const [isDisabled, setIsDisabled] = useState(false);

  const doorTypes = [
    { id: 1, name: 'Single Door',                   imageUrl: '/images/door-1.png' },
    { id: 2, name: 'Single Door - Left Side Lite',  imageUrl: '/images/door-2.png' },
    { id: 3, name: 'Single Door - Right Side Lite', imageUrl: '/images/door-3.png' },
    { id: 4, name: 'Single Door - Side Lites',      imageUrl: '/images/door-4.png' },
    { id: 5, name: 'Double Door',                   imageUrl: '/images/door-5.png' },
    { id: 6, name: 'Double Door - Left Side Lite',  imageUrl: '/images/door-6.png' },
    { id: 7, name: 'Double Door - Right Side Lite', imageUrl: '/images/door-7.png' },
    { id: 8, name: 'Double Door - Side Lites',      imageUrl: '/images/door-8.png' }
  ];
  const [doorData, setDoorData] = useState({});
  const [isViewDetailsVisible, setIsViewDetailsVisible] = useState(false);
  const [viewDetailsData, setViewDetailsData] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [displayPrices, setDisplayPrices] = useState(false);

  //const viewRef = useRef();
  const itemSelectorRef = useRef(null); //ai
  const [selectedDoor, setSelectedDoor] = useState(null);
  
  //---setters functions....
  const [quantityValue, setQuantityValue] = useState("");
  const [discountValue, setDiscountValue] = useState(0);

  const [frameColorValue, setFrameColorValue] = useState("");
  const [frameWidthValue, setFrameWidthValue] = useState("40\"");
  const [frameHeightValue, setFrameHeightValue] = useState("80\"");
  const [sideLiteSizeValue, setSideLiteSizeValue] = useState("0\"");
  const [frameDepthValue,setFrameDepthValue]  = useState("3\"");
  const [retractableScreenValue, setRetractableScreenValue]  = useState("");
  const [screenFrameMatchValue, setScreenFrameMatchValue] = useState("");
  const [sillOptionsValue, setSillOptionsValue] = useState("Standard");
  const [transomValue, setTransomValue] = useState("");
  const [overallHeightValue, setOverallHeightValue] = useState("");
  const [transomGlassValue, setTransomGlassValue] = useState({ value: "", label: "" });

  const [hardwareCollectionValue, setHardwareCollectionValue] = useState("Liverpool");
  const [hardwareFinishValue, setHardwareFinishValue] = useState("White");
  
  const [swingValue, setSwingValue] = useState("Inswing");
  const [hingesValue, setHingesValue] = useState("Left");
  const [hingesCoverColorValue, setHingesCoverColorValue] = useState("White");
  
  const [optionSValue, setOptionSValue] = useState({ value: "", label: "" });

  const [glassDividersValue, setGlassDividersValue] = useState("");
  const [glassDividersVerticalValue, setGlassDividersVerticalValue] = useState("");
  const [glassDividersHorizontalValue, setGlassDividersHorizontalValue] = useState("");
  const [exteriorFinishValue, setExteriorFinishValue] = useState("white");
  const [interiorFinishValue, setInteriorFinishValue] = useState("white");
 
  const [gentekColorValue,  setGentekColorValue]  = useState({ value: "", label: "" });
  const [gentekColorValue2, setGentekColorValue2] = useState({ value: "", label: "" });
  const [gentekColorValue3, setGentekColorValue3] = useState({ value: "", label: "" });
  const [gentekColorValue4, setGentekColorValue4] = useState({ value: "", label: "" });
  const [gentekColorValue5, setGentekColorValue5] = useState({ value: "", label: "" });
  const [gentekColorValue6, setGentekColorValue6] = useState({ value: "", label: "" });
  const [gentekColorValue7, setGentekColorValue7] = useState({ value: "", label: "" });

  const [exteriorDoorValue, setExteriorDoorValue] = useState("");
  const [interiorDoorValue, setInteriorDoorValue] = useState("");
  const [screenFrameColorValue, setScreenFrameColorValue] = useState("white");
  
  const [sideLiteTypeEticomValue, setSideLiteTypeEticomValue] = useState("");
  const [sideLiteOptionsEticomValue, setSideLiteOptionsEticomValue] = useState({ value: "", label: "" });
  const [glassDividersSideLiteEticomValue, setGlassDividersSideLiteEticomValue] = useState("");
  const [glassDividersHorizontalSideLiteEticomValue, setGlassDividersHorizontalSideLiteEticomValue] = useState("");
  const [glassDividersVerticalSideLiteEticomValue, setGlassDividersVerticalSideLiteEticomValue] = useState("");

  const [exteriorFinishSideLiteEticomValue, setExteriorFinishSideLiteEticomValue] = useState("white");
  const [interiorFinishSideLiteEticomValue, setInteriorFinishSideLiteEticomValue] = useState("white");
  const [locationTagValue, setLocationTagValue] = useState("");
  const [notesValue, setNotesValue]             = useState("");

  const requiredKeys = ["CascadingCombo1", "CascadingCombo2", "CascadingCombo3", "CascadingCombo4", "CascadingCombo5"];
  const [CascadingComboValue,  setCascadingComboValue]   = useState([]);
  const [CascadingComboValue1, setCascadingComboValue1]  = useState();
  const [CascadingComboValue2, setCascadingComboValue2]  = useState();
  const [CascadingComboValue3, setCascadingComboValue3]  = useState();
  const [CascadingComboValue4, setCascadingComboValue4]  = useState();
  const [CascadingComboValue5, setCascadingComboValue5]  = useState();
  const [isLoading, setIsLoading] = useState(false);

   //email dialog
   const [showEmailDialog, setShowEmailDialog] = useState(false);
   const [isSending, setIsSending] = useState(false);
   const [customerEmail, setCustomerEmail] = useState("");

   useEffect(() => {
     const loadEmail = async () => {
       const email = await getCustomerEmail(fkCustomerId);
       setCustomerEmail(email || "no customer email found");
     };
   
     if (fkCustomerId) {
       loadEmail();
     }
   }, [fkCustomerId]); 
 
   const handleSendEmail = async (recipient) => {
     setShowEmailDialog(true); 
   };

  const handlePdfDownload = async () => {
    setIsLoading(true);
    try {
      // toPdfAuto picks server-side vs legacy based on USE_PDF_SERVER (constants.js).
      await toPdfAuto({
        container: ".view-details",
        filename: `${doorData?.frameData?.selectedDoor?.name || "No name available"}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveQuote = async (bSaveAndBack = false) => {
    try {
      const userId    = getCookie('user_id');

      if (parseInt(userId) !== parseInt(fkUserId)){
        await alertC("this quote item doesn't belong to you, you can't modify and save it.")
        if (bSaveAndBack) {
          navigate('/quotes', {
            state: {
              quoteId: quoteId,           // ID of the parent quote
              quoteItemId: quoteItemId    // ID of the updated item (optional)
            }
          });
        }
        return;
      }
      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-US', {
        year: '2-digit', 
        month: '2-digit', 
        day: '2-digit'
      });
      setLastDateSaved(formattedDate); //put the new last date...
      doorData.document.orderDate = formattedDate;
        
      if (!quoteId && !quoteItemId) {
        await alertC('create new Quote and NEW item')
      }
      if (quoteId && !quoteItemId && !newQuoteItemId) {//('Save NEW item in existing Quote')
        const payload = {
          fkQuoteId: quoteId,
          doorData: doorData,
          itemType: "entrydooreticom" 
        };
        const itemRow = await authFetchRequest(
                          `/itemquotes/`,
                          payload,
                          "POST",
                          { Authorization: `Bearer ${getCookie("access_token")}` }
                      );
                      setNewQuoteItemId(itemRow?.id);
      }//^^^     
      if ((quoteId && quoteItemId) || (quoteId && newQuoteItemId)) { //Quote & ItemQuote exist, just re-save
          const payload = {
            fkQuoteId: quoteId,
            doorData: doorData 
          };
          const currentQuoteItemId = quoteItemId || newQuoteItemId;
          const itemRow = await authFetchRequest(
                            `/itemquotes/${currentQuoteItemId}`,
                            payload,
                            "PUT",
                            { Authorization: `Bearer ${getCookie("access_token")}` }
                        );
      }//^^^
      if (bSaveAndBack) {
          navigate('/quotes', {
            state: {
              quoteId: quoteId,           // ID of the parent quote
              quoteItemId: quoteItemId    // ID of the updated item (optional)
            }
          });
      }
      return;

    } catch (err) {
      console.error("❌ Failed to save quote and item quote:", err);
      alert("Failed to save.");
    }
  };

  useEffect(() => {
        setCascadingComboValue1(CascadingComboValue[0]?.value || "NA");
        setCascadingComboValue2(CascadingComboValue[1]?.value || "NA");
        setCascadingComboValue3(CascadingComboValue[2]?.value || "NA");
        setCascadingComboValue4(CascadingComboValue[3]?.value || "NA");
        setCascadingComboValue5(CascadingComboValue[4]?.value || "NA");
  }, [CascadingComboValue]); // ✅ Ensures state updates when cascadingComboValue changes


  useEffect(() => {
    if (viewItem === 'readonly'){
        setIsDisabled(true);
        setDisplayPrices(true);
    }
    const fetchData = async () => {
      try {
        if (!quoteId || !quoteItemId) {
          console.warn("❌ Missing quoteId or quoteItemId—skipping fetch.");
          return;
        }
  
        console.log(`🔍 Fetching data from: ${UrlDev}/itemquotes/${quoteItemId}`);  
        const data = await authFetch(`/itemquotes/${quoteItemId}`);
        console.log("✅ API Response Data:", JSON.stringify(data, null, 2));
  
        if (!data?.doorData) {
          console.warn("❌ No valid doorData found.");
          alert("No valid doorData found.");
          return;
        }
  
        // Set the doorData state
        setDoorData(data.doorData);
  
        // Check if `selectedDoor` exists in `frameData`
        const selectedDoorItem = data.doorData?.frameData?.selectedDoor;
  
        if (selectedDoorItem) {
          console.log("✅ Selected door detected:", selectedDoorItem.name);
          
          // Update item selector via ref
          if (itemSelectorRef.current) {
            itemSelectorRef.current.setSelectedItem(selectedDoorItem.name);
          }
  
          setSelectedDoor(selectedDoorItem); // Update state
          setFormData(data.doorData); // Populate form
          setIsViewDetailsVisible(true);
        }
  
        setHasLoaded(true); // Mark as loaded
  
      } catch (error) {
        console.error("❌ Fetch error:", error);
        alert(`Error: ${error.message}`);
      }
    };
  
    fetchData();
  }, [quoteId, quoteItemId]); // Runs when these values change  
  

    const transomPatch = (value) => {
      if ( value === "None"){
        let element = document.getElementById("OverallHeight"); 
            if (element){
              element.style.display = "none";
              const label = element.previousElementSibling;
              if (label) {
                  label.style.display = "none";
              }
            }
            element = document.getElementById("TransomGlass"); 
            if (element){TransomGlass
              element.style.display = "none";
              const label = element.previousElementSibling;
              if (label) {
                  label.style.display = "none";
              }
            }
      }
    }

    // Function to map doorData to state setters
    const setFormData = (doorData) => {
      setQuantityValue(doorData?.frameData?.quantity || "1");
      setDiscountValue(doorData?.discounts?.discount || "0");
      setFrameWidthValue(doorData?.frameData?.frameWidthLabel || "40\"");
      setFrameHeightValue(doorData?.frameData?.frameHeightLabel || "80\"");
      setSideLiteSizeValue(doorData?.frameData?.sideLiteSizeLabel || "0\"");
      setFrameDepthValue(doorData?.frameData?.frameDepth || "3\"");
      setRetractableScreenValue(doorData?.frameData?.retractableScreen || "");
      setScreenFrameMatchValue(doorData?.frameData?.screenFrameMatch || "");
      setSillOptionsValue(doorData?.frameData?.sillOptions || "Standard");
  
      setTransomValue(doorData?.transomData?.transom || "None");
      setOverallHeightValue(doorData?.transomData?.OverallHeightLabel || "");
      setTransomGlassValue({value: doorData?.transomData?.transomGlass, label: doorData?.transomData?.transomGlass_label});
      transomPatch(doorData?.transomData?.transom || "None");
  
      setHardwareCollectionValue(doorData?.frameData?.hardwareCollection || "Liverpool");
      setHardwareFinishValue(doorData?.frameData?.hardwareFinish || "White");
  
      setSwingValue(doorData?.frameData?.swing || "Inswing");
      setHingesValue(doorData?.frameData?.hinges || "Left");
      setHingesCoverColorValue(doorData?.frameData?.hingesCoveColor || "White");

      setOptionSValue({value: doorData?.doorLite?.optionsS, label: doorData?.doorLite?.optionsS_label});

      setGlassDividersValue(doorData?.doorLite?.glassDividers);
        setGlassDividersVerticalValue(doorData?.doorLite?.glassDividersVertical);
        setGlassDividersHorizontalValue(doorData?.doorLite?.glassDividersHorizontal);
        setExteriorFinishValue(doorData?.doorLite?.exteriorFinish);
        setInteriorFinishValue(doorData?.doorLite?.interiorFinish);
    
        setGentekColorValue5 ({value: doorData?.doorLite?.gentekColor5, label: doorData?.doorLite?.gentekColor5_label});
        setGentekColorValue6({value: doorData?.doorLite?.gentekColor6, label: doorData?.doorLite?.gentekColor6_label});

        setGentekColorValue ({value: doorData?.finish?.gentekColor, label: doorData?.finish?.gentekColor_label});
        setGentekColorValue2({value: doorData?.finish?.gentekColor2, label: doorData?.finish?.gentekColor2_label});

        setGentekColorValue7({value: doorData?.finish?.gentekColor7, label: doorData?.finish?.gentekColor7_label});

        setGentekColorValue3 ({value: doorData?.sideLite?.gentekColor3, label: doorData?.sideLite?.gentekColor3_label});
        setGentekColorValue4({value: doorData?.sideLite?.gentekColor4, label: doorData?.sideLite?.gentekColor4_label});

      setExteriorDoorValue(doorData?.finish?.exteriorDoor);
      setInteriorDoorValue(doorData?.finish?.interiorDoor);
      setScreenFrameColorValue(doorData?.finish?.screenFrameColor);

      setSideLiteTypeEticomValue(doorData?.sideLite?.sideLiteType);
      setSideLiteOptionsEticomValue({value: doorData?.sideLite?.sideLiteOptionsS, label: doorData?.sideLite?.sideLiteOptionsS_label});
      setGlassDividersSideLiteEticomValue(doorData?.sideLite?.glassDividers);
      setGlassDividersHorizontalSideLiteEticomValue(doorData?.sideLite?.glassDividersHorizontal);
      setGlassDividersVerticalSideLiteEticomValue(doorData?.sideLite?.glassDividersVertical);
      setExteriorFinishSideLiteEticomValue(doorData?.sideLite?.exteriorFinish);
      setInteriorFinishSideLiteEticomValue(doorData?.sideLite?.interiorFinish);
      setLocationTagValue(doorData?.notes?.LocationTag);
      setNotesValue(doorData?.notes?.notes);

      if (doorData?.additionalItems !== undefined){
          setCascadingComboValue1(doorData?.additionalItems?.CascadingCombo1 || "NA");
          setCascadingComboValue2(doorData?.additionalItems?.CascadingCombo2 || "NA");
          setCascadingComboValue3(doorData?.additionalItems?.CascadingCombo3 || "NA");
          setCascadingComboValue4(doorData?.additionalItems?.CascadingCombo4 || "NA");
          setCascadingComboValue5(doorData?.additionalItems?.CascadingCombo5 || "NA");
          //alert(JSON.stringify(doorData.additionalItems, null, 2));
          const convertedCombos = Object.entries(doorData?.additionalItems)
                .filter(([_, val]) => val !== "NA")
                .map(([id, value]) => ({ id, value }));
          setCascadingComboValue(convertedCombos);
      }
      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-US', {
        year: '2-digit', 
        month: '2-digit', 
        day: '2-digit'
      });
      setLastDateSaved(doorData?.document?.orderDate || date);
    };

    const getControlValues = () => {
        // Collect control IDs and values dynamically from controlMap
        const values = controlMap.map((control) => {
            const controlValue = document.getElementById(control.id)?.value || "No Value";
            return { id: control.id, value: controlValue };
        });
        setViewDetailsData(values); // Set data for ViewDetails
    };

    const toggleViewDetails = () => {
        //getControlValues(); // Gather control values before showing
        setIsViewDetailsVisible((prev) => !prev); // Toggle window
    };
    const togglePrices = () => {
      setDisplayPrices(!displayPrices);
  };


  const controlMap = [
  
    { id: "SideLiteTypeEticom", component: <SideLiteTypeEticom 
      disabled={isDisabled}
        value={sideLiteTypeEticomValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setSideLiteTypeEticomValue(newValue); 
        console.log("SideLiteTypeEticom changed to:", newValue)}
        }  label="Side Lite Type" />,  
      position: [1, 1], status: "active", expandableSectionId: "SideLite" },

    { id: "SideLiteOptionsEticom",  component: <SideLiteOptionsEticom 
          disabled={isDisabled}
          value={sideLiteOptionsEticomValue} // ✅ Pass current state value
          showPics={true}
          onChange={(newValue) => 
          { setSideLiteOptionsEticomValue(newValue); 
          console.log("setSideLiteOptionsEticomValue changed to:", newValue)}
        }/>,   position: [2, 1], status: "active", expandableSectionId: "SideLite" },

    { id: "GlassDividersSideLiteEticom",
      component: (
          <GlassDividersSideLiteEticom
              childs={[
                  "GlassDividersHorizontalSideLiteEticom",
                  "GlassDividersVerticalSideLiteEticom",
                  "ExteriorFinishSideLiteEticom",
                  "InteriorFinishSideLiteEticom"
              ]}
              disabled={isDisabled}
              value={glassDividersSideLiteEticomValue} // ✅ Pass current state value
              onChange={(newValue) => {
                  setGlassDividersSideLiteEticomValue(newValue);
                  console.log("GlassDividersSideLiteEticom changed to:", newValue);
              }}
          />
      ),
      position: [3, 1], status: "active", expandableSectionId: "SideLite"
    },

   { id: "GlassDividersHorizontalSideLiteEticom",  component: <GlassDividersHorizontalSideLiteEticom
        disabled={isDisabled} 
        value={glassDividersHorizontalSideLiteEticomValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGlassDividersHorizontalSideLiteEticomValue(newValue); 
         console.log("GlassDividersHorizontalSideLiteEticom changed to:", newValue)}
        }/>,   position: [4, 1], status: "active", expandableSectionId: "SideLite" },

    { id: "GlassDividersVerticalSideLiteEticom", component: <GlassDividersVerticalSideLiteEticom 
        value={glassDividersVerticalSideLiteEticomValue} // ✅ Pass current state value
        disabled={isDisabled}
        onChange={(newValue) => 
        { setGlassDividersVerticalSideLiteEticomValue(newValue); 
         console.log("GlassDividersVerticalSideLiteEticom changed to:", newValue)}
        }/>,   position: [4, 2], status: "active", expandableSectionId: "SideLite" },

    { id: "ExteriorFinishSideLiteEticom", component: <ExteriorFinishSideLiteEticom 
        label='Grills Exterior Color'
        disabled={isDisabled}
        value={exteriorFinishSideLiteEticomValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setExteriorFinishSideLiteEticomValue(newValue); 
         console.log("SideLite: Grills Exterior Color changed to:", newValue)}
        }/>,   position: [5, 1], status: "active", expandableSectionId: "SideLite" },

    { id: "GentekColor3",  component: <GentekColor controlId={3} 
        disabled={isDisabled}
        value={gentekColorValue3} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGentekColorValue3(newValue); 
        console.log("GentekColor changed to:", newValue)}
        }
        label='Grills Gentek Color Exterior' color={exteriorFinishSideLiteEticomValue} dividers={glassDividersSideLiteEticomValue}/>,   
        position: [5, 2], status: "active", expandableSectionId: "SideLite" },

    { id: "InteriorFinishSideLiteEticom", component: <InteriorFinishSideLiteEticom 
        disabled={isDisabled}
        label='Grills Interior Color' 
        value={interiorFinishSideLiteEticomValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setInteriorFinishSideLiteEticomValue(newValue); 
         console.log("SideLite: Grills Interior Color changed to:", newValue)}
        }/>,   position: [6, 1], status: "active", expandableSectionId: "SideLite" },

    { id: "GentekColor4", component: <GentekColor controlId={4}
        disabled={isDisabled}
        value={gentekColorValue4} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGentekColorValue4(newValue); 
        console.log("GentekColor4 changed to:", newValue)}
        }
        label='Grills Gentek Color Exterior' color={interiorFinishSideLiteEticomValue} dividers={glassDividersSideLiteEticomValue}/>,   
        position: [6, 2], status: "active", expandableSectionId: "SideLite" },

    // Section - Finish starts
    { id: "ExteriorDoor", component: <ExteriorDoor 
        disabled={isDisabled}
        value={exteriorDoorValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setExteriorDoorValue(newValue); 
        console.log("ExteriorDoor changed to:", newValue)}
        }  label="Color Exterior" />,  
        position: [1, 1], status: "active", expandableSectionId: "Finish" },

    { id: "GentekColor", component: <GentekColor controlId={1}
        disabled={isDisabled}
        value={gentekColorValue} // ✅ Pass current state value 
        onChange={(newValue) => 
        { setGentekColorValue(newValue); 
        console.log("GentekColor changed to:", newValue)}
        }
        label='Gentek Color Exterior' color={exteriorDoorValue}/>,   
        position: [1, 2], status: "active", expandableSectionId: "Finish" },

    { id: "InteriorDoor", component: <InteriorDoor 
        disabled={isDisabled}
        value={interiorDoorValue} // ✅ Pass current state value 
        onChange={(newValue) => 
        { setInteriorDoorValue(newValue); 
        console.log("InteriorDoor changed to:", newValue)}
        } label="Color Interior" />,   
        position: [2, 1], status: "active", expandableSectionId: "Finish" },

    { id: "GentekColor2", component: <GentekColor controlId={2} 
          disabled={isDisabled}
          value={gentekColorValue2} // ✅ Pass current state value 
          onChange={(newValue) => 
          { setGentekColorValue2(newValue); 
          console.log("GentekColor2 changed to:", newValue)}
          }
          label='Gentek Color Interior'
          color={interiorDoorValue}/>, 
          position: [2, 2], status: "active", expandableSectionId: "Finish" },

    { id: "ScreenFrameColor", component: <ScreenFrameColor 
        disabled={isDisabled}
        value={screenFrameColorValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setScreenFrameColorValue(newValue); }
    }/>,      
    position: [3, 1], 
    status: retractableScreenValue === "Yes" ? "active" : "inactive", 
    expandableSectionId: "Finish" },

    { id: "GentekColor7", component: <GentekColor controlId={7} 
      disabled={isDisabled}
      value={gentekColorValue7} // ✅ Pass current state value 
      onChange={(newValue) => 
      { setGentekColorValue7(newValue); 
      console.log("GentekColor7 changed to:", newValue)}
      }
      label='Gentek Screen Frame Color'
      color={screenFrameColorValue}/>, 
      position: [3, 2], 
      status: retractableScreenValue === "Yes" ? "active" : "inactive", 
      expandableSectionId: "Finish" },
    // Section - Finish ends


    { id: "LocationTag", component: <LocationTag  
      disabled={isDisabled}
      value={locationTagValue} // ✅ScreenDetails Pass current state value  
      onChange={(newValue) => 
      { setLocationTagValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "Notes" },

    { id: "Notes",  component: <Notes  
      disabled={isDisabled}
      value={notesValue} // ✅ScreenDetails Pass current state value  
      onChange={(newValue) => 
      { setNotesValue(newValue); }
    }/>, position: [2, 1], status: "active", expandableSectionId: "Notes" },

 // Section - Frame starts   
    { id: "Quantity",    component: <Quantity
          disabled={isDisabled}
          value={quantityValue} // ✅ Pass current state value  
          onChange={(newValue) => 
          { setQuantityValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "SizingAndFrame" },
    { id: "FrameWidth",  component: <FrameWidthEticom 
          disabled={isDisabled}
          value={frameWidthValue} // ✅ Pass current state value
          onChange={(newValue) => 
          { setFrameWidthValue(newValue); }}
          label="Door Frame Width"
          passSelectedDoor={selectedDoor}
      />, position: [2, 1], status: "active", expandableSectionId: "SizingAndFrame" },
    { id: "FrameHeight",  component: <FrameHeightEticom 
         disabled={isDisabled}
         value={frameHeightValue} // ✅ Pass current state value
         onChange={(newValue) => 
        { setFrameHeightValue(newValue); }
    }/>, position: [2, 2], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "SideLiteSize",  component: <SideLiteSize 
        disabled={isDisabled}
        value={sideLiteSizeValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setSideLiteSizeValue(newValue); }
    }/>, position: [2, 3], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "FrameDepth",  component: <FrameDepth 
      disabled={isDisabled}
      screen={retractableScreenValue}
      value={frameDepthValue} // ✅ Pass current state value
      onChange={(newValue) => { setFrameDepthValue(newValue)}
    }/>,   position: [3, 1], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "SillOptions",  component: <SillOptions 
      disabled={isDisabled}
      value={sillOptionsValue} // ✅ Pass current state value
      onChange={(newValue) => { setSillOptionsValue(newValue)}
    }/>,   position: [3, 3], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "RetractableScreen",  component: <RetractableScreen 
        disabled={isDisabled}
        value={retractableScreenValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setRetractableScreenValue(newValue); }
    }/>,   position: [4, 1], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "ScreenFrameMatch",  component: <ScreenFrameMatch 
      disabled={isDisabled}
      value={screenFrameMatchValue} // ✅ Pass current state value
      onChange={(newValue) => 
      { setScreenFrameMatchValue(newValue); }
    }/>,position: [4, 2], status: "inactive", expandableSectionId: "SizingAndFrame" },
 
    { id: "Transom",  component: <Transom
      disabled={isDisabled}
      value={transomValue} // ✅ Pass current state value 
      onChange={(newValue) => 
      { setTransomValue(newValue); }}
      childs={["OverallHeight", "TransomGlass"]} 
      />,   position: [5, 1], status: "active", expandableSectionId: "SizingAndFrame" },

    
    { id: "OverallHeight",  component: <OverallHeight 
        disabled={isDisabled}
        value={overallHeightValue} // ✅ Pass current state value 
        onChange={(newValue) => 
        { setOverallHeightValue(newValue); }
    }/>,      
      position: [5, 2], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "TransomGlass",  component: <TransomGlass 
        disabled={isDisabled}
        value={transomGlassValue} // ✅ Pass current state value
        showPics={true}
        onChange={(newValue) => 
        { setTransomGlassValue(newValue); }
    }/>,     position: [5, 3], status: "active", expandableSectionId: "SizingAndFrame" },
    

    { id: "HardwareCollection",  component: <HardwareCollection
      disabled={isDisabled}
      value={hardwareCollectionValue} // ✅ Pass current state value
      onChange={(newValue) => 
      { setHardwareCollectionValue(newValue); } 
    }/>,   position: [6, 1], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "HardwareFinish",  component: <HardwareFinish
      disabled={isDisabled}
      value={hardwareFinishValue} // ✅ Pass current state value
      onChange={(newValue) => 
      { setHardwareFinishValue(newValue); }  
    }/>,   position: [6, 2], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "Swing",  component: <Swing 
        disabled={isDisabled}
        value={swingValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setSwingValue(newValue); }
    }/>, position: [7, 1], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "Hinges",  component: <Hinges 
        disabled={isDisabled}
        value={hingesValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setHingesValue(newValue); 
          console.log("Hinges changed to:", newValue)}
    }/>, position: [7, 2], status: "active", expandableSectionId: "SizingAndFrame" },

    { id: "HingesCoverColor",  component: <HingesCoverColor 
        disabled={isDisabled}
        value={hingesCoverColorValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setHingesCoverColorValue(newValue);} 
    } />,    
      position: [7, 3], status: "active", expandableSectionId: "SizingAndFrame" },
// Section - Frame ends   

// Section - DoorLite starts   
    { id: "OptionS",  component: <OptionS 
        disabled={isDisabled}
        value={optionSValue} // ✅ Pass current state value
        showPics={true}
        onChange={(newValue) => 
        { setOptionSValue(newValue);} 
      }/>,   position: [1, 1], status: "active", expandableSectionId: "DoorLite" },

    { id: "GlassDividers",
      component: (
          <GlassDividers
              childs={[
                  "GlassDividersHorizontal",
                  "GlassDividersVertical",
                  "ExteriorFinish",
                  "InteriorFinish"
              ]}
              disabled={isDisabled}
              value={glassDividersValue} // ✅ Pass current state value
              onChange={(newValue) => {
                  setGlassDividersValue(newValue);
                  console.log("GlassDividers changed to:", newValue);
              }}
          />
      ),
      position: [2, 1], status: "active", expandableSectionId: "DoorLite"
    },

    { id: "GlassDividersHorizontal", component: <GlassDividersHorizontal 
        disabled={isDisabled}
        value={glassDividersHorizontalValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGlassDividersHorizontalValue(newValue); 
          console.log("GlassDividersHorizontal changed to:", newValue)}
    }/>,   position: [3, 1], status: "active", expandableSectionId: "DoorLite" },

    { id: "GlassDividersVertical",  component: <GlassDividersVertical
        disabled={isDisabled}
        value={glassDividersVerticalValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGlassDividersVerticalValue(newValue); 
          console.log("GlassDividersVertical changed to:", newValue)}
    }/>,   position: [3, 2], status: "active", expandableSectionId: "DoorLite" },

    { id: "ExteriorFinish",  component: <ExteriorFinish 
        disabled={isDisabled}
        label= 'Grills Exterior Color' 
        value={exteriorFinishValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setExteriorFinishValue(newValue); 
          console.log("Doorlite Grills Exterior Color changed to:", newValue)}
    }/>,   position: [4, 1], status: "active", expandableSectionId: "DoorLite" },

    { id: "GentekColor5",  component: <GentekColor controlId={5} 
        disabled={isDisabled} 
        value={gentekColorValue5} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGentekColorValue5(newValue); 
        console.log("GentekColor5 changed to:", newValue)}
        }
        label='Grills Gentek Color Exterior' color={exteriorFinishValue} dividers={glassDividersValue}
    />,  position: [4, 2], status: "active", expandableSectionId: "DoorLite" },

    { id: "InteriorFinish",  component: <InteriorFinish label='Grills Interior Color' 
      disabled={isDisabled}
        value={interiorFinishValue} // ✅ Pass current state value
        onChange={(newValue) => 
        { setInteriorFinishValue(newValue); 
          console.log("Doorlite Grills Interior Color changed to:", newValue)}
        }
    />,   position: [5, 1], status: "active", expandableSectionId: "DoorLite" },

    { id: "GentekColor6",  component: <GentekColor controlId={6}
        disabled={isDisabled}
        value={gentekColorValue6} // ✅ Pass current state value
        onChange={(newValue) => 
        { setGentekColorValue6(newValue); 
        console.log("GentekColor6 changed to:", newValue)}
        }
        label='Grills Gentek Color Exterior' color={interiorFinishValue} dividers={glassDividersValue}
    />,  position: [5, 2], status: "active", expandableSectionId: "DoorLite" },

    {
      id: "CascadingCombo", component: <CascadingCombo 
        disabled={isDisabled}
        label = 'item'
        value={CascadingComboValue}
        onChange={(newValue) => 
        { setCascadingComboValue(newValue); 
        console.log("CascadingCombo changed to:", newValue)}
        }     
      />,  // ✅ Render your component inside the expandable panel
      position: [1, 1], // Adjust position as needed
      status: "active",
      expandableSectionId: "AdditionalItems"
    },
    { id: "Discount",    component: <Discount
      disabled={isDisabled}
      label="Discount %"
      value={discountValue} // ✅ Pass current state value  
      onChange={(newValue) => 
      { setDiscountValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "Discounts" },

    
// Section - DoorLite ends  
  ];
  
  useEffect(() => {
      if (selectedDoor && ![1, 5].includes(selectedDoor.id)) {
          const element = document.getElementById("SideLiteSize");
          const panel   = document.getElementById("Side Lite");
          if (element) {
              element.style.display = "block";
              const label = element.previousElementSibling; // Fetch the label, if present
              if (label) {
                  label.style.display = "block";
              }
              if (panel){
                  panel.style.display = "block";
              }
          }
      }
      else{
        const element = document.getElementById("SideLiteSize");
        const panel   = document.getElementById("Side Lite");

        if (element) {
            element.style.display = "none";
            const label = element.previousElementSibling; // Fetch the label, if present
            if (label) {
                label.style.display = "none";
            }
            if (panel){
              panel.style.display = "none";
            }
        }
      }
  }, [selectedDoor]);

  if (!doorData.calc) {
    setDoorData((prev) => ({
      ...prev,
      calc: {
        baseSubtotal: null,
        subtotal: null,
        discountedSubtotal: null,
        tax: null,
        total: null,
      },
    }));
  }
  // Callback to update calc data
  const updateCalcData = (newCalc) => {
    setDoorData((prev) => ({
      ...prev,
      calc: {
        ...prev.calc,
        ...newCalc, // Merge new calc values
      },
    }));
  };


  ///let doorData = {}; - old one
  doorData.calc = doorData.calc || {};
  doorData.frameData = {}; 
  doorData.transomData = {}; 
  doorData.doorLite = {};
  doorData.sideLite = {};
  doorData.finish = {};
  doorData.notes = {};
  doorData.additionalItems = {};
  doorData.discounts = {};
  doorData.document = {};
  doorData.document.type = "Entry Door";
  doorData.document.orderNumber = `${quoteId}/${quoteItemId || newQuoteItemId || 'new item'}`; //, fkCustomerId
  doorData.document.reference = `${reference_no}`;
  doorData.document.orderDate = `${lastDateSaved}`;
  doorData.quoteTemplate = "euro_entry_door";
  doorData.priceRules = "euro_entry_door_priceRules";
  doorData.quote = 1;
  doorData.frameData.selectedDoor = selectedDoor;
  //doorData.frameData.doorSize = doorSize;
  //doorData.frameData.doorHeight = doorHeight;
  doorData.frameData.tilt = false;
  doorData.displayPrices = displayPrices;
  doorData.frameData.quantity = quantityValue || 1;
  doorData.discounts.discount = discountValue || 0;
  doorData.frameData.frameWidthLabel = frameWidthValue;
  doorData.frameData.frameWidth = formatToDecimal(frameWidthValue);
  doorData.frameData.frameWidthRound = Math.round(doorData.frameData.frameWidth);

  doorData.frameData.frameHeightLabel = frameHeightValue;
  doorData.frameData.frameHeight = formatToDecimal(frameHeightValue);
  doorData.frameData.frameHeightRound = Math.round(doorData.frameData.frameHeight);

  doorData.frameData.sideLiteSizeLabel = sideLiteSizeValue || 0;
  doorData.frameData.sideLiteSize = formatToDecimal(sideLiteSizeValue) || 0;
  doorData.frameData.sideLiteSizeRound = Math.round(doorData.frameData.sideLiteSize) || 0;

  doorData.frameData.sillOptions = sillOptionsValue;
  doorData.frameData.frameDepth = frameDepthValue;

  doorData.frameData.retractableScreen = retractableScreenValue;
  doorData.frameData.screenFrameMatch = screenFrameMatchValue;
  doorData.frameData.hardwareCollection = hardwareCollectionValue;
  doorData.frameData.hardwareFinish = hardwareFinishValue;

  
  doorData.frameData.swing = swingValue;
  doorData.frameData.hinges = hingesValue;
  doorData.frameData.hingesCoveColor = hingesCoverColorValue;
  doorData.frameData.frameColor = frameColorValue;
  
  doorData.transomData.transom = transomValue || 0;
  doorData.transomData.OverallHeightLabel = overallHeightValue;
  doorData.transomData.OverallHeight = formatToDecimal(overallHeightValue);
  doorData.transomData.OverallHeightRound = Math.round(doorData.transomData.OverallHeight);
  doorData.transomData.transomGlass = transomGlassValue.value; 
  doorData.transomData.transomGlass_label = transomGlassValue.label;
  if (doorData.transomData.transom === 'None'){
    doorData.transomData.OverallHeight = '';
    doorData.transomData.OverallHeightLabel = '';
  }

  doorData.doorLite.optionsS = optionSValue.value;
  doorData.doorLite.optionsS_label = optionSValue.label;

  doorData.doorLite.glassDividers = glassDividersValue;
  doorData.doorLite.glassDividersVertical = glassDividersVerticalValue;
  doorData.doorLite.glassDividersHorizontal = glassDividersHorizontalValue;
  doorData.doorLite.exteriorFinish = exteriorFinishValue;
  doorData.doorLite.interiorFinish = interiorFinishValue;
  doorData.doorLite.gentekColor5       = gentekColorValue5.value;
  doorData.doorLite.gentekColor5_label = gentekColorValue5.label;
  doorData.doorLite.gentekColor6       = gentekColorValue6.value;
  doorData.doorLite.gentekColor6_label = gentekColorValue6.label;

  doorData.sideLite.sideLiteType = sideLiteTypeEticomValue;
  doorData.sideLite.sideLiteOptionsS = sideLiteOptionsEticomValue.value;
  doorData.sideLite.sideLiteOptionsS_label = sideLiteOptionsEticomValue.label;

  doorData.sideLite.glassDividers = glassDividersSideLiteEticomValue;
  doorData.sideLite.glassDividersVertical = glassDividersVerticalSideLiteEticomValue;
  doorData.sideLite.glassDividersHorizontal = glassDividersHorizontalSideLiteEticomValue;
  doorData.sideLite.exteriorFinish = exteriorFinishSideLiteEticomValue;
  doorData.sideLite.interiorFinish = interiorFinishSideLiteEticomValue;
  doorData.sideLite.gentekColor3       = gentekColorValue3.value;
  doorData.sideLite.gentekColor3_label = gentekColorValue3.label;
  doorData.sideLite.gentekColor4       = gentekColorValue4.value;
  doorData.sideLite.gentekColor4_label = gentekColorValue4.label;


  doorData.finish.exteriorDoor = exteriorDoorValue;
  doorData.finish.interiorDoor = interiorDoorValue;
  doorData.finish.screenFrameColor = screenFrameColorValue;

  doorData.finish.gentekColor        = gentekColorValue.value;
  doorData.finish.gentekColor_label  = gentekColorValue.label;
  doorData.finish.gentekColor2       = gentekColorValue2.value;
  doorData.finish.gentekColor2_label = gentekColorValue2.label;

  doorData.finish.gentekColor7       = gentekColorValue7.value;
  doorData.finish.gentekColor7_label = gentekColorValue7.label;
  
  doorData.notes.LocationTag         = locationTagValue;
  doorData.notes.notes               = notesValue;

  /*
  doorData.additionalItems.CascadingCombo1 = CascadingComboValue1;
  doorData.additionalItems.CascadingCombo2 = CascadingComboValue2;
  doorData.additionalItems.CascadingCombo3 = CascadingComboValue3;
  doorData.additionalItems.CascadingCombo4 = CascadingComboValue4;
  doorData.additionalItems.CascadingCombo5 = CascadingComboValue5;
*/
  CascadingComboValue.forEach(({ id, value }) => {
    doorData.additionalItems[id] = value;
  });
  requiredKeys.forEach(key => {
    if (!doorData.additionalItems.hasOwnProperty(key)) {
        doorData.additionalItems[key] = "NA";
    }
  });

  //alert(JSON.stringify(doorData.additionalItems, null, 2));


 
 
  //alert(doorData.additionalItems.CascadingCombo3)
  //alert(JSON.stringify(CascadingComboValue, null, 2));

  const doorDataCopy = { ...doorData };
  const doorDataCopy2 = { ...doorData }; 
  //alert(JSON.stringify(doorData, null, 2));
 //aaa




  return (
<div className='entire-container'>
    <div className="door-container">
      <div className="toolbar-container">
        <div className="toolbar">
            <button
              className="toolbar-button"
              onClick={toggleViewDetails}
            >
              {isViewDetailsVisible ? "Hide Details" : "View Details"}
            </button>
            <button className="toolbar-button" onClick={togglePrices} disabled={!isViewDetailsVisible} >
              {displayPrices ? "Hide Prices" : "Show Prices"}
            </button>
            <button
              className={`toolbar-button ${isLoading ? "loading" : ""}`}
              onClick={handlePdfDownload}
              disabled={!isViewDetailsVisible || isLoading}
            >
            {isLoading ? (
              <span className="spinner"></span>
            ) : (
              "📄 PDF"
            )}
          </button>
          <button className={`toolbar-button`}  onClick={() => handleSendEmail(true)} disabled={!isViewDetailsVisible}>
              ✉️ Email
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSaveQuote(false)}>
              💾 Save
            </button>
            <button className={`toolbar-button`}  onClick={() => handleSaveQuote(true)}>
              💾 Save & Exit
            </button>
            <button className={`toolbar-button`}onClick={() => setIsDisabled(prev => !prev)}>
            {isDisabled ? "Enable Form" : "Disable Form"}
            </button>
        </div>
      </div>
      <ExpandableSection title1="Select Door Type" state="true">
        <ItemSelector ref={itemSelectorRef} items={doorTypes} selectedDoor={selectedDoor} onSelect={setSelectedDoor} disabled={isDisabled} />
      </ExpandableSection>
      {selectedDoor && (
        <div >
          <div >
            <div className="door"><p>{selectedDoor.name}</p></div>
          </div>
          <ExpandableSection 
            title="Sizing & Frame" 
            panelLocation="2"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "SizingAndFrame")}
            state="true" >
          </ExpandableSection>

          <ExpandableSection
            title="Door Lite"
            panelLocation="3"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "DoorLite")}
          />
          <ExpandableSection
            title="Side Lite"
            panelLocation="4"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "SideLite")}
            style={{
              display: selectedDoor && ![1, 5].includes(selectedDoor.id) ? "block" : "none"
            }}
          />

          <ExpandableSection
            title="Finish"
            panelLocation="5"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "Finish")}
          />

          <ExpandableSection 
            title="Additional Items" 
            panelLocation="6"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "AdditionalItems")}    
          />

          <ExpandableSection
            title="Notes"
            panelLocation="7"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "Notes")}
            state="true" >
          </ExpandableSection>

          <ExpandableSection
            title="Discounts"
            panelLocation="8"
            controlMap={controlMap.filter((control) => control.expandableSectionId === "Discounts")}
           />
        </div>
      )}
    </div>
    <div className="door-container shift-down image-container"  >
      {selectedDoor ? 
        <div className="fixed-container">
            <Drawing 
              doorData={doorDataCopy2}
              selectedDoor={selectedDoor}
              frameColor={frameColorValue}
              frameWidth={frameWidthValue}
              frameHeight={frameHeightValue}
              sideLiteSize={sideLiteSizeValue} 
              overallHeight={overallHeightValue}
              hinges={hingesValue}
              transom={{
                   transom: {value: transomValue},
                   overallHeight: {value: overallHeightValue}
              }}
              swing={swingValue}
              doorLite={{
                  glassDividers: { value: glassDividersValue },
                  glassDividersVertical: { value: glassDividersVerticalValue },
                  glassDividersHorizontal: { value: glassDividersHorizontalValue },
                  exteriorFinish: { value: exteriorFinishValue },
                  interiorFinish: { value: interiorFinishValue }
                }
              }
            />
            <DrawTopView
              doorData={doorDataCopy2}
            />
        </div> : 'select sizes to create an image'}        
    </div>
 

            {/*<ViewDetails isVisible={isViewDetailsVisible} data={viewDetailsData} />*/}
            {selectedDoor && (
            <ViewDetails 
                  isVisible={isViewDetailsVisible}
                  data={viewDetailsData}
                  doorData={doorDataCopy}
                  updateCalcData={updateCalcData} // Pass the callback
                  drawing={
                      selectedDoor ? (
                          <Drawing
                              doorData={doorDataCopy2}
                              selectedDoor={selectedDoor}
                              frameColor={frameColorValue}
                              frameWidth={frameWidthValue}
                              frameHeight={frameHeightValue}
                              sideLiteSize={sideLiteSizeValue}
                              overallHeight={overallHeightValue}
                              hinges={hingesValue}
                              transom={{
                                  transom: { value: transomValue },
                                  overallHeight: { value: overallHeightValue },
                              }}
                              swing={swingValue}
                              doorLite={{
                                  glassDividers: { value: glassDividersValue },
                                  glassDividersVertical: { value: glassDividersVerticalValue },
                                  glassDividersHorizontal: { value: glassDividersHorizontalValue },
                                  exteriorFinish: { value: exteriorFinishValue },
                                  interiorFinish: { value: interiorFinishValue },
                              }}
                          />
                      ) : null
                  }
                  drawTopView={
                      selectedDoor ? <DrawTopView doorData={doorDataCopy} /> : null
                  }
            />
                )}
            {/* end of View Details Sliding Window */}
            {showEmailDialog && (
            <EmailDialog
              simplePdf={true}
              isOpen={showEmailDialog}
              onClose={() => setShowEmailDialog(false)}
              isSending={isSending}
              setIsSending={setIsSending}
              customerEmail={customerEmail}
              container=".view-details"         // optional, default is ".view-details"
              filename="Quote"
              /* subject/message intentionally not set so EmailDialog loads
                 default_subject/default_message from Mailer Settings. */
            />
            )}                       
  </div>
  );
};

export default EntryDoorEticom;
